import { asHtmlString } from './asHtmlString';

export const getGlobalHtmlStringFallback = (reason: string) =>
    asHtmlString(`
        Sorry, we couldn't display the appropriate message for the following situation: ${reason}. Please contact our support team so we can fix this as soon as possible. Thank you!
    `);
